/**
 * StatsBar — a flex row of pill-shaped badges showing key counts.
 * Used at the top of list pages to display totals and breakdowns.
 */

type StatItem = {
  readonly label: string;
  readonly value: number;
  readonly color?: string;
};

type Props = {
  readonly items: ReadonlyArray<StatItem>;
};

export function StatsBar({ items }: Props): React.JSX.Element {
  if (items.length === 0) return <></>;
  return (
    <div style={styles.bar}>
      {items.map((item) => (
        <span key={item.label} style={styles.pill}>
          <span style={{ ...styles.value, color: item.color ?? "inherit" }}>
            {item.value.toLocaleString()}
          </span>
          <span style={styles.label}>{item.label}</span>
        </span>
      ))}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "4px 12px",
    borderRadius: 16,
    background: "var(--color-bg-secondary)",
    border: "1px solid var(--color-border)",
    fontSize: 13,
    lineHeight: 1,
  },
  value: {
    fontWeight: 700,
    fontVariantNumeric: "tabular-nums",
  },
  label: {
    color: "var(--color-text-secondary)",
    fontWeight: 400,
  },
};
